<template>
    <div>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="3">
                <b-form-group label="Дата:" label-cols-md="3" class="bolded-label">
                    <date-picker
                        placeholder="Выберите дату"
                        v-model="dateForInput"
                        format="DD/MM/YYYY"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!---------------------регион------------------------->
                <b-form-group label="Регион (Область, город, район, село):" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать регион"
                        track-by="code"
                        label="text"
                        v-model="reg"
                        :options="listReg"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        @input="chgRegions"
                        ref="regionRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!---------------------тип бюджета------------------------->
                <b-form-group label="Тип бюджета:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать тип бюджета"
                        track-by="code"
                        label="name"
                        v-model="budget_type"
                        :options="list_budget_types"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        ref="budgetTypeRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!----------------Администратор abp------------------->
                <b-form-group label="Администратор:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        v-model="curAbp"
                        track-by="func"
                        label="name"
                        placeholder="Выбрать адм. программ"
                        :options="abpBase"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        @input="chgAbp"
                        ref="abpRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-------------Ед. измерения---------------------->
                <b-form-group label="Единица измерения:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать единицу измерения"
                        v-model="curUnit"
                        :options="unit"
                        :custom-label="unitLabel"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        class="w-150px"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="curAbp && curAbp.hasOwnProperty('func') && (curAbp.func === '261' || curAbp.func === 261) && parentCompanyBase.length > 0" class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!-------------Гос. учреждение---------------------->
                <b-form-group label="Отдел образования:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        v-model="curParentComp"
                        track-by="name"
                        label="name"
                        placeholder="Выбрать отдел образования"
                        :options="parentCompanyBase"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        ref="compRef"
                        @input="chgParentGU"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!-------------Гос. учреждение---------------------->
                <b-form-group label="Гос. учреждение:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        v-model="curComp"
                        track-by="name"
                        label="name"
                        placeholder="Выбрать гос. учреждение"
                        :options="companyBase"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        ref="compRef"
                        @input="chgComp"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col>
                <div style="display: flex; align-items: center">
                    <b-form-checkbox v-model="сutness_switch" switch />
                    <span style="font-weight: 600;font-size: 0.7777777778rem;">В разрезе ГУ</span>
                </div>
            </b-col>
        </b-row>
<!--        <b-row class="py-2 bb-row">-->
<!--            <b-button variant="success" @click="downloadRep" :disabled="isLoad">Скачать</b-button>-->
<!--        </b-row>-->
    </div>
</template>

<script>
import store from "../../../services/store";
import {Ax} from "@/utils";
import DatePicker from "vue2-datepicker";
import axios from 'axios'

export default {
    name: "treasury-form-420",
    components: { DatePicker },
    data() {
        return {
            obl: null,

            listReg: [],
            reg: null,

            list_budget_types: [],
            budget_type: null,

            date: '',
            dateForInput: null,

            abpBase: [],
            curAbp: null,

            companyBase: [],
            curComp: null,
            parentCompanyBase: [],
            curParentComp: null,

            curCut: {code: 0, name_ru: 'АБП'},
            сutness_switch: false,
            cutnessList: [
                {code: 0, name_ru: 'АБП'},
                {code: 1, name_ru: 'ГУ'}
            ],

            languages: ['Казахский', 'Русский'],
            selectedLanguage: null,

            unit: ['tenge', 'thousand_tenge', 'million_tenge'],
            curUnit: 'tenge',

            isLoad: false,
        }
    },
    async mounted() {
        // сегодняшняя дата
        this.dateForInput = new Date();
        this.date = new Date().toLocaleDateString().split('.').reverse().join('-');

        await this.getObl();
    },
    methods: {
        unitLabel(key) {
            return this.$t(`modules.budget_execution_monitoring.treasury_forms.${key}`);
        },

        async getObl() {
            try {
                await fetch('/api-py/get-budget-obl/' + store.state._instanceCode)
                    .then(response => response.json())
                    .then(json => {
                        this.obl = json.obl;
                        // this.reg = json.region;
                    });
                await this.loadRegions();
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
        },

        async loadRegions() {
            try {
                this.listReg = [];
                this.reg = null;
                if (this.date.includes('/')) {
                    this.date = this.date.split('/').reverse().join('-')
                }
                const response = await fetch(`/api-py/get_kato_for_420/${this.obl}/${this.date}/${this.usrId}`);
                this.listReg = await response.json();
                if (this.listReg && this.listReg.length > 0) {
                    this.reg = this.listReg[0];
                }

            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }

            await this.chgRegions();
        }, // справочник регионов

        async chgRegions() {
            if (this.reg && this.reg.code) {
                // await this.loadBudjetTypes();
                await this.loadAbp();
            }
        },

        async loadAbp() {
            let result = [];
            this.curAbp = null;
            this.abpBase = []
            try {
                if (this.reg) {
                    result = await fetch(`/api-py/get_abp_for_420/${this.date}/${this.reg.code}/${this.usrId}`)
                        .then(response => response.json());
                    this.abpBase = result;
                }
            } catch (error) {
                this.abpBase = [];
                this.makeToast('danger', 'Ошибка загрузки Адм. программа', error);
            }
            const res = [this.setNameLang({
                func: 0,
                name_ru: 'Все',
                name_kk: 'Барлығы'
            }, 'func')]
            for (const el of result) {
                res.push(this.setNameLang(el, 'func'));
            }
            this.abpBase = res;

            if (this.abpBase.length > 0) {
                this.curAbp = this.abpBase[0];
            }
            await this.chgAbp();
        },

        async chgAbp() {
            if ((this.curAbp && this.curAbp.func) || (this.curAbp && this.curAbp.func === 0)) {
                if (this.curAbp.func === "261") {
                    await this.loadParenGU();
                } else {
                    await this.loadCompany();
                }
            }
        },

        async loadCompany() {
            let result = [];
            this.curComp = null;
            this.companyBase = []
            if (!this.curAbp) {
                return;
            }
            try {
                if (this.reg && this.curAbp.func !==0) {
                    let path = `/api-py/get_gu_for_420/${this.date}/${this.curAbp.func}/${this.reg.code}/${this.usrId}`
                    if (this.curAbp.func === '261') {
                        if (this.parentCompanyBase.length) {
                            if (this.curParentComp && this.curParentComp.hasOwnProperty('gu') && this.curParentComp.gu) {
                                path += `/${this.curParentComp.gu}`
                            }
                        } else {
                             path += `/-1`
                        }
                    }
                    result = await fetch(path)
                        .then(response => response.json());
                    this.companyBase = result;
                }
            } catch (error) {
                this.companyBase = [];
                this.makeToast('danger', 'Ошибка загрузки Гос. учереждение', error);
            }
            const res = [this.setNameLang({
                gu: 0,
                name_ru: 'Все',
                name_kk: 'Барлығы'
            }, 'gu')]
            if (result && result.length > 0) {
                for (const el of result) {
                    res.push(this.setNameLang(el, 'gu'));
                }
            }
            this.companyBase = res;

            if (this.companyBase.length > 0) {
                this.curComp = this.companyBase[0];
            }
            await this.chgComp();
        },
        async chgComp() {
            if (this.curComp && this.curComp.hasOwnProperty('gu')) {
                await this.loadBudjetTypes();
            }
        },
        async loadParenGU() {
            this.curParentComp = null;
            this.parentCompanyBase = [];
            const that = this
            await axios.get(`/api-py/get_gu_for_261_abp_420/${this.date}/${this.curAbp.func}/${this.usrId}`).then(resp => {
                if (resp.status === 200) {
                    let res = resp.data;
                    if (res.length > 0) {
                        if (res.length > 1) {
                            res = [{
                                gu: 0,
                                name_ru: 'Все',
                                name_kk: 'Барлығы'
                            }, ...resp.data]
                        }
                        for (const el of res) {
                            that.parentCompanyBase.push(that.setNameLang(el, 'gu'))
                        }
                        that.curParentComp = that.parentCompanyBase[0]
                    }
                }
            })
            await this.chgParentGU()
        },
        async chgParentGU() {
            await this.loadCompany()
        },
        async loadBudjetTypes() {
            try {
                if (this.reg) {
                    const response = await fetch(`/api-py/get_type_budjet_for_420/${this.date}/${this.reg.code}/${this.usrId}/${this.curComp.gu}`);
                    this.list_budget_types = await response.json();
                    if (this.list_budget_types && this.list_budget_types.length > 0) {
                        const region = this.reg.code;
                        const yy = region.slice(2, 4)
                        const zz = region.slice(4, 6)
                        let defBtype = '01'
                        if (region.slice(2, 6) === '0000' || region.slice(2, 6) === '0101') {
                            defBtype = '02'
                        } else {
                            if (yy !== '01') {
                                defBtype = '03'
                                if (zz !== '01') {
                                    defBtype = '06'
                                }
                            }
                        }
                        if (region.slice(2, 6) !== '0000') {
                            if (yy !== '01' && zz === '00') {
                                this.list_budget_types = this.list_budget_types.filter(b => b.code === '03' || b.code === '06')
                            } else {
                                this.list_budget_types = this.list_budget_types.filter(b => b.code === defBtype)
                            }
                        }
                        this.list_budget_types.unshift({code: '00', name: 'Все'})
                        const defType = this.list_budget_types.find(b => b.code === defBtype)
                        if (defType !== undefined) this.budget_type = defType;
                        else this.budget_type = this.list_budget_types[0];
                    } else {
                        this.budget_type = null
                    }
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }
        },

        setNameLang(obj, codeName) {
            let txt = obj['name_' + this.$i18n.locale];
            if (txt === undefined) {
                txt = obj.name_ru;
            }
            if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined && obj[codeName] !== 0) {
                txt = obj[codeName] + ' - ' + txt;
            }
            const el = Object.assign({}, obj);
            el.name = txt;
            return el;
        },

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },

        downloadRep() {
            try {
                if (
                    !(this.reg && this.reg.hasOwnProperty('code') && this.reg.code) ||
                    !(this.budget_type && this.budget_type.hasOwnProperty('code') && this.budget_type.code) ||
                    !(this.curAbp && this.curAbp.hasOwnProperty('func')) ||
                    !(this.curComp && this.curComp.hasOwnProperty('gu')) ||
                    !(this.curUnit) ||
                    !(this.date)
                ) {
                    this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
                    this.$emit('onDownload', 0)
                    return
                }
                let parentGuName = ''

                this.makeToast('info', this.$i18n.t('modules.execution.attention'), this.$i18n.t('modules.execution.treasury_forms_informative_message'));
                this.isLoad = true
                let parent_gu = null
                if (this.curAbp && this.curAbp.hasOwnProperty('func') && this.curAbp.func === '261') {
                    parentGuName = "Все"
                    if (this.parentCompanyBase.length) {
                        parent_gu = this.curParentComp && this.curParentComp.hasOwnProperty('gu') && this.curParentComp.gu? this.curParentComp.gu: null
                    } else {
                        parent_gu = '-1'
                    }
                } else {
                    parent_gu = null
                }
                if (parent_gu && parent_gu !== '-1') {
                    parentGuName = this.curParentComp.name
                }
              //  && this.curParentComp && this.curParentComp.hasOwnProperty('gu') && this.curParentComp.gu? this.curParentComp.gu: (this)
                const filter = {
                    region: this.reg.code,
                    budgetType: this.budget_type.code,
                    budgetTypeName: this.budget_type.name,
                    unit: this.curUnit,
                    locale: this.$i18n.locale,
                    date: this.date,
                    abp: this.curAbp.func,
                    abpName: this.curAbp.name,
                    gu: this.curComp.gu,
                    guName: this.curComp.name,
                    parent_gu: parent_gu,
                    parent_gu_name: parentGuName,
                    user_id: this.usrId,
                    cutness: this.curCut.code
                };
                Ax(
                    {
                        url: '/api-py/treasury-form-xls-rep-420',
                        method: 'POST',
                        responseType: 'blob',
                        data: filter
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Форма 04-20.xlsx');// or any other extension
                        this.$emit('onDownload', 100)
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.$emit('onDownload', 0)
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
                this.$emit('onDownload', 0)
            } finally {
                this.isLoad = false
            }
        },
    },
    watch: {
        async dateForInput() {
            this.date =`${this.dateForInput.getFullYear()}-${this.dateForInput.getMonth() + 1}-${this.dateForInput.getDate()}`
            await this.loadRegions();
        },
        сutness_switch() {
            this.curCut = this.cutnessList[Number(this.сutness_switch)]
        }
    },
    computed: {
        usrId() {
            if (!store.state.user.sub) { return null; }
            return store.state.user.sub;
        }
    }
}
</script>

<style scoped>

</style>